import type { Participant } from '../../api/types'
import styles from './DealPanel.module.css'

/** How each person's decision-maker judgement reads once it has been made. */
export const JUDGEMENT_LABEL = {
  yes: 'Decision maker',
  no: 'Not the decision maker',
  unclear: 'Unclear',
} as const

/**
 * Who was on the calls, read-only.
 *
 * The judgement shown is the user's own, stored on the deal. Nothing here infers
 * it from the transcript: authority is a human call (docs/16 section 0.1).
 */
export function PeopleList({ participants }: { participants: readonly Participant[] }) {
  const named = participants.filter((person) => person.name.trim())

  if (named.length === 0) {
    return <p className={styles.absent}>Nobody identified yet.</p>
  }

  return (
    <ul className={styles.people}>
      {named.map((person, index) => (
        <li key={`${person.name}-${index}`}>
          <span className={styles.personName}>{person.name}</span>
          {person.role ? <span className={styles.personRole}> ({person.role})</span> : null}
          <span className={styles.personJudgement}>
            {person.decision_maker ? JUDGEMENT_LABEL[person.decision_maker] : 'Not reviewed'}
          </span>
        </li>
      ))}
    </ul>
  )
}
